import React from 'react';
import ReactDOM from 'react-dom';
import { AuthRouter, ProtectedRoute } from '@screentone/addon-auth-wrapper';
import { Redirect, BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { IconSymbol } from '@screentone/core'; // TODO: remove, once we upgrade all our add-ons
import { Provider } from 'react-redux';

import configureStore from './store/configure';
import { checkMode, READ_ONLY } from './constants/environment';
import { READ_ONLY_BANNER_MESSAGE } from './constants/messages';
import './components/App.scss';
import { PrintIdForm, ErrorPage, ChartView as PrintChartView } from './components/printView';

import packageJSON from '../../package.json';

const FEEDBACK_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSe4J0AaWk4aJFx1AdR9AtmmZAl_aSKSEtJhfUd0C_SN5jAClw/viewform';

const SearchView = React.lazy(() => import('./components/searchview'));
const ChartView = React.lazy(() => import('./components/chartview'));
const ChangeLog = React.lazy(() => import('./components/changelog'));

const store = configureStore();

const envMap = {
  production: 'prd',
  beta: 'int',
  dev: 'dev',
  local: 'local',
};

function App() {
  const isReadOnly = checkMode() === READ_ONLY;
  // eslint-disable-next-line no-underscore-dangle
  const isIllustrator = !!window.__adobe_cep__;
  const testing = window.IS_TESTING === 'true';
  const redirectUri = `${window.location.origin}/login/callback`;

  const myAppConfig = {
    name: 'Chartlos',
    env: envMap[window.ENVIRONMENT],
    key: 'charts',
    illustration: 'chartlos',
    slack: {
      channel_name: 'chartlos',
      channel_url: 'https://dowjones.slack.com/archives/C4F0ANBU4',
    },
    requestAccess: {
      url: 'https://hooks.slack.com/services/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',
    },
    feedbackUrl: FEEDBACK_FORM_URL,
    maintenance:
      isReadOnly && READ_ONLY_BANNER_MESSAGE
        ? { announcement: { id: READ_ONLY_BANNER_MESSAGE, content: READ_ONLY_BANNER_MESSAGE } }
        : null,
    versions: [
      {
        name: '',
        version: packageJSON.version,
      },
    ],
    defaultColorTheme: 'light',
  };

  const AUTH_CONFIG = {
    issuer: window.OKTA_ISSUER,
    clientId: window.APP_ID,
    redirectUri,
  };

  return (
    <React.Fragment>
      <Provider store={store}>
        {testing || isIllustrator ? (
          <Router>
            <Switch>
              <Route exact path="/wsj/print/chart/:id">
                <PrintChartView />
              </Route>
              <Route exact path="/">
                <PrintIdForm />
              </Route>
              <Route exact path="/wsj">
                <PrintIdForm />
              </Route>
              <Route path="/">
                <ErrorPage />
              </Route>
            </Switch>
          </Router>
        ) : (
          <>
            <AuthRouter app={myAppConfig} authConfig={AUTH_CONFIG}>
              <Redirect from="/djmg" to="/" />
              <ProtectedRoute exact path="/:property" component={SearchView} />
              <ProtectedRoute exact path="/:property/chart/:id?" component={ChartView} />
              <ProtectedRoute path="/changelog" component={ChangeLog} />
            </AuthRouter>
            <IconSymbol />
          </>
        )}
      </Provider>
    </React.Fragment>
  );
}

ReactDOM.render(<App />, document.querySelector('#main'));
